import Headline, { type Props } from "./Headline";

export default function H5({size = "md", ...props}:Props) {
  return <Headline tag="h5" size={size} {...props}/>;
}